import { render, staticRenderFns } from "./LevelCalculationBasis.vue?vue&type=template&id=194c4df8&scoped=true&"
import script from "./LevelCalculationBasis.vue?vue&type=script&lang=ts&"
export * from "./LevelCalculationBasis.vue?vue&type=script&lang=ts&"
import style0 from "./LevelCalculationBasis.vue?vue&type=style&index=0&id=194c4df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194c4df8",
  null
  
)

export default component.exports